var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",class:{
    'content-loading': _vm.isLoading,
  }},[_vm._t("content"),(_vm.isLoading)?_c('Loading',{attrs:{"text-info":_vm.textInfo}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }